import React from "react";
import SubPicture from "components/comp/SubPicture";
import HeroImg from "assets/images/hygateone/hero.jpg";
import HyGateOneIntro from "components/comp/HyGateOneIntro";
import HyGateOneAccess from "components/comp/HyGateOneAccess";
import HyGateOneControlTower from "components/comp/HyGateOneControlTower";
import HyGateOneSpaceSecurity from "components/comp/HyGateOneSpaceSecurity";

const ProductHyGateOne = () => {
  const url = "https://www.hygateone.com";

  return (
    <main className="page-sub">
      <section className="company-main">
        <SubPicture img={HeroImg} fit="contain" />
        <HyGateOneIntro />
        <HyGateOneAccess />
        <HyGateOneControlTower />
        <HyGateOneSpaceSecurity />
        <div className="btn-container">
          <button
            type="button"
            className="btn btn-more"
            onClick={() => {
              window.open(url, "_blank", "noopener,noreferrer");
            }}
          >
            HyGateOne 바로가기
          </button>
        </div>
      </section>
    </main>
  );
};

export default ProductHyGateOne;
